import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackWhatsAppClick } from "@/lib/analytics";

const getPageMessage = (pathname: string): string => {
  // Remove leading slash and get the path segments
  const segments = pathname.replace(/^\//, "").split("/");
  const firstSegment = segments[0]?.toLowerCase() || "";
  const secondSegment = segments[1]?.toLowerCase() || "";

  // Destination detail pages
  if (firstSegment === "destinations" && secondSegment) {
    const destinationName = secondSegment
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    return `Hello Feel Free Holidays, I would like to know more about your ${destinationName} holiday packages. Please share details.`;
  }

  // Main pages with specific messages
  switch (firstSegment) {
    case "":
      return "Hello Feel Free Holidays, I'm interested in planning a trip. Please share your best travel packages.";
    case "about":
      return "Hello Feel Free Holidays, I would like to know more about your company and services.";
    case "services":
      return "Hello Feel Free Holidays, I'm interested in your travel services. Please share details about your offerings.";
    case "destinations":
      return "Hello Feel Free Holidays, I would like to explore your destination packages. Please share more details.";
    case "blog":
      return "Hello Feel Free Holidays, I came across your travel blog and would like assistance planning my trip.";
    case "contact":
      return "Hello Feel Free Holidays, I would like assistance regarding your travel services.";
    case "faq":
      return "Hello Feel Free Holidays, I have some questions about your travel services. Can you help?";
    case "visa":
      return "Hello Feel Free Holidays, I need assistance with visa services. Please share the requirements.";
    default:
      return "Hello Feel Free Holidays, I'm interested in planning a trip. Please share details.";
  }
};

export const WhatsAppButton = () => {
  const location = useLocation();
  const phoneNumber = "917490019959";
  const message = getPageMessage(location.pathname);
  
  // Use wa.me format - official WhatsApp link format with better cross-platform support
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      onClick={() => trackWhatsAppClick('floating_button')}
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat on WhatsApp"
    >
      <div className="relative">
        <Button
          size="lg"
          className="rounded-full h-16 w-16 shadow-2xl hover:scale-110 transition-all duration-300 bg-[#25D366] hover:bg-[#20BA5A] text-white border-4 border-white animate-bounce-subtle"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle className="h-7 w-7" fill="currentColor" />
        </Button>
        <span className="absolute -top-1 -right-1 flex h-4 w-4">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-4 w-4 bg-green-400"></span>
        </span>
      </div>
      <span className="absolute right-20 top-1/2 -translate-y-1/2 bg-[#25D366] text-white px-4 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 group-hover:right-[4.5rem] transition-all duration-300 shadow-lg">
        💬 Chat with us!
      </span>
    </a>
  );
};
